import script from "./ConfirmationPopupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationPopupModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationPopupModal.vue?vue&type=style&index=0&id=361ab385&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361ab385"]])

export default __exports__